import * as React from "react";
import * as RDS from 'ouisys-engine/dist/common-types/RemoteDataState';
import PhoneInput from "ouisys-phone-input/dist/common/PhoneInput";
import Loader from "../Loader/index";
import { Translate, injectIntl } from "../../localization/index";
import { useState, useRef } from "react";
import {tracker} from "ouisys-engine/dist/reducers/strategy"
import { handleFormSubmit } from "ouisys-engine/dist/utilities/handleSubmitNumber";
import { MSISDNEntryFailure, MSISDNEntrySuccess } from "ouisys-engine/dist/reducers/pinFlow/PinTypes";

const PhoneNumberEntryStep = (props:{
  msisdn: string;
  rds: RDS.RemoteDataState<MSISDNEntryFailure, MSISDNEntrySuccess>;
  onEnd: (msisdn: string, extraParams?: { [key: string]: string }) => void;
  isHeaderEnrichmentSuccess:boolean;
  locale:string;
})=> {

  const [msisdn, setMsisdn] = useState<string>(props.msisdn);
  const [internationalNumber, setInternationalNumber] = useState<string>(props.msisdn)
  const [isValid, setIsValid] = useState<boolean>(false)
  const [isMsisdnFilled, setIsMsisdnFilled] = useState<boolean>(false)
  const phoneInputRef = useRef<HTMLInputElement>()

  return (
    <div className="subscriptionArea">
      <form
        onSubmit={ev => {
          ev.preventDefault();

          handleFormSubmit({
            isHeaderEnrichmentSuccess:props.isHeaderEnrichmentSuccess,
            country:process.env.country,
            setInternationalNumber,
            onEnd:props.onEnd,
            internationalNumber
          })
        }}
      >
        <div className="number-entry">
            {/* NORMAL PIN */}
            {!props.isHeaderEnrichmentSuccess  &&

              <div>
                <h1 className="msisdnLabel"><Translate id="msisdnLabel" defaultMessage="Put your mobile number below" /></h1>

                <div className="phoneInputWrap">
                  <PhoneInput
                    inputElementRef={phoneInputRef}
                    placeholder="Nomor Ponsel Anda"
                    msisdn={msisdn}
                    countryCode={process.env.country}
                    showFlag={false}
                    showMobileIcon={true}
                    showError={true}
                    onChange={({ msisdn, isValid, internationalNumber, ...args }) => {
                      console.log(args, internationalNumber)
                      console.log("internationalNumber", internationalNumber)
                      setMsisdn(msisdn)
                      setIsValid(isValid)
                      setInternationalNumber(internationalNumber)
                    }
                    }
                    onKeyPress={(ev)=>{
                      if(isMsisdnFilled == false && ev.target.value.length >= 5){
                        setIsMsisdnFilled(true)
                      }
                    }}
                    onPaste={()=>{
                      if(isMsisdnFilled == false){
                        setIsMsisdnFilled(true)
                      }
                      tracker.customEvent(
                        "MSISDN-State",
                        "copypaste",
                        "MsisdnPasted"
                      );
                    }}
                    onBlur={(ev)=>{
                      if(isMsisdnFilled == false && ev.target.value.length >= 5){
                        setIsMsisdnFilled(true)
                        tracker.customEvent(
                          "MSISDN-State",
                          "autofill",
                          "AutoFill"
                        );
                      }
                    }}
                  />
                </div>

                <button id="msisdn-submit-button" type="submit" className="btn"  disabled={RDS.IsLoading(props.rds) || !isValid}>
                  <Translate id="msisdnButton" defaultMessage="Send SMS Now" />
                </button>
              </div>
              ||
              // HE SUCCESS SHOW BUTTON WHILE HIDING INPUT
              <div>
                <h1 className="msisdnLabel"><Translate id="msisdnLabelForHe" defaultMessage="Click To Send Pin" /></h1>

                <button  id="msisdn-submit-button" type="submit" className="btn dcbp" >
                  <Translate id="subscribe" defaultMessage="Subscribe Now" />
                </button>
              </div>

            }

            {
              RDS.WhenLoading(null, () => <div>
                <Loader />
                <Translate id="loadingLabel" defaultMessage="Please wait...">Please wait...</Translate>
              </div>)(props.rds)
            }
        </div>
        <div>
          {RDS.WhenFailure(null, (err: MSISDNEntryFailure) => {
            console.log("the err", err)
              return (
                <div className="errorMsg">
                  <Translate id={err.errorType}/>
                  <br/>
                  {
                    err.errorType == "AlreadySubscribed" &&
                    <a target="_blank" href={err.productUrl}><Translate id="goToProductLabel" defaultMessage="Go to Product" /></a>
                  }
                </div>
              )
          })(props.rds)}
        </div>
      </form>
    </div>
  );
}


export default injectIntl(PhoneNumberEntryStep);